<template>
  <v-dialog v-model="show" persistent max-width="480">
    <v-card class="mx-auto">
      <v-card-title class="white--text orange darken-4">
        {{ title }} {{ objNm }}
        <v-spacer></v-spacer>
        <v-btn class="mx-2" fab dark small color="grey" @click="closeDlg">
          <v-icon dark> mdi-close </v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pt-4">
        <v-text-field
          label="Search Text"
          color="primary"
          single-line
          clearable
          v-model="searchText"
          v-on:keyup.enter="search"
        >
          <template v-slot:append>
            <v-btn depressed tile color="primary" class="ma-0" @click="search"
              >search</v-btn
            >
          </template>
        </v-text-field>
      </v-card-text>

      <v-virtual-scroll :items="items" :item-height="50" height="300">
        <template v-slot:default="{ item }">
          <v-list-item>
            <v-list-item-icon>
              <v-chip>{{ item.uid }}</v-chip>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ item.email }}</v-list-item-title>
            </v-list-item-content>

            <v-list-item-action>
              <v-btn small @click="select(item)">
                Select
                <v-icon color="orange darken-4" right > mdi-open-in-new </v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </template>
      </v-virtual-scroll>
    </v-card>
  </v-dialog>
</template>

<script>
import { AdminAPI } from "@/api";
import _ from "lodash";
import * as moment from "moment/moment";

export default {
  name: "UserDlg",
  props: {
    value: Boolean,
    objNm: String
  },
  data: () => {
    return {
      title: "Detail",
      items: [
        {
          uid: 123,
          text: "xxx",
        },
        {
          uid: 104,
          text: "xxxx",
        },
        {
          uid: 104,
          text: "xxxx",
        },
      ],
      searchText: "",
    };
  },
  computed: {
    show: {
      get() {
        console.log("show", this.value);
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },

  watch: {
    value: function (a) {
      if (a) {
        this.initialize();
      }
    },
  },
  beforeCreate: () => {},

  async created() {
    this.initialize();
  },

  methods: {
    closeDlg() {
      this.show = false;
    },
    /**
     * new ,edit form...
     */
    makeInput() {},
    select(item) {
      this.show = false;
      console.log("item", item)
      // this.returnVal = item
      this.$emit("selectItem", item);
    },
    initialize() {
      console.log("init...");
      this.search()
      // select objNm
      //
    },
    search() {
      console.log("search");
      AdminAPI.list({
        objNm: "User",
        page: 0,
        perpage: 40,
        search: {
          email: this.searchText,
        },
      }).then((list) => {
        console.log("list", list);
        this.items = list.data.list;
      });
    },
    remove() {},
    edit() {},
    close() {},

    async save() {},
  },
};
</script>

<style >
</style>



// WEBPACK FOOTER //
// src/components/controls/UserDlg.vue